import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { Tooltip } from 'src/app/model/tooltip';
import { Router, ActivatedRoute } from '@angular/router';
import { CurrencyFunctionalityService } from '../../shared/utilities/functionality/currency-functionality.service';

@Component({
  selector: 'app-percentage-currency',
  templateUrl: './percentage-currency.component.html',
  styleUrls: ['./percentage-currency.component.scss']
})
export class PercentageCurrencyComponent implements OnInit {

  @Input() controllerData;
  @Input() parent: FormGroup;
  @Input() tooltipData: Tooltip = new Tooltip();
  @Input() childCurrency: string;
  @Input() controlName;
  @Input() componentName;
  @Input() source;
  @Output() percentagecurrencyChangeEventEmitter: EventEmitter<string> = new EventEmitter<string>();
  @Output() currenyChildEmitter: EventEmitter<string> = new EventEmitter<string>();

  protected value = '';
  yourPensionACE;
  constructor(private router: Router, private route: ActivatedRoute,
              private activatedRoute: ActivatedRoute) {
    this.yourPensionACE = this.activatedRoute.snapshot.data.contentData.yourPension;
  }

  ngOnInit() {
  }

  currencyChangeHandler(val) {
    this.controllerData.controlName = this.controlName;
    this.controllerData.currentValue = val;
     
    this.percentagecurrencyChangeEventEmitter.emit(this.controllerData);
  }

  validateInput = () => {
    this.currenyChildEmitter.emit();
    this.calculateTFCAmount();
  }
  invalidTaxfree = (message): string => {
    message = message.replace('[dealpartner]', (this.source ? this.source : ''));
    return message;
  }
  setMinLTA = (errorMessage): string => {
    let MinValue = this.yourPensionACE.minPensionValue; 
    if(this.parent && this.parent['value'] && this.parent['value']['productType'])  { 
      MinValue = (this.parent['value']['productType'] != 'C') ?  this.yourPensionACE.GIAPensionValue : this.yourPensionACE.minPensionValue;
    }
    errorMessage = errorMessage.replace('[LTAMin]',
      CurrencyFunctionalityService.convertNumberToCurrency(MinValue));
    return errorMessage;
  }

  calculateTFCAmount(){

    let Amount = Number(this.controllerData.currentValue) > 0 ? Number(this.controllerData.currentValue) : 0;
    let fundAmount = (this.controllerData && this.controllerData.fundAmount > 0) ? this.controllerData.fundAmount : 0;
    let totalAmount = (fundAmount * Amount) / 100;

    let amountWithOutRoundOff = CurrencyFunctionalityService.getNumberWithoutRoundOff(totalAmount,2);

    return amountWithOutRoundOff;


  }
}
